/**
 * @file Defines actions and methods map
 */
export const ACTIONS = {
    all: 'all',
    add: 'add',
    edit: 'edit',
    delete: 'delete',
    read: 'read',
};

export const METHODS = {
    post: 'POST',
    put: 'PUT',
    patch: 'PATCH',
    delete: 'DELETE',
    get: 'GET',
};
// This map will be used to transform methods to actions
export const ACTION_METHOD_MAP = {
    [ACTIONS.all]: null,
    [ACTIONS.add]: [METHODS.post, METHODS.put],
    [ACTIONS.edit]: [METHODS.put, METHODS.patch],
    [ACTIONS.delete]: [METHODS.delete],
    [ACTIONS.read]: [METHODS.get],
};

export const ACTION_LIST = Object.keys(ACTIONS);
